#@import Booking.Views.Picker
#@import Booking.Presenters.DateTimePicker
#@import Booking.Views.Calendar
#@import Booking.Views.TimeBubbles
#@export Booking.Views.DateTimePicker

class Booking.Views.DateTimePicker extends Booking.Views.Picker

  presenter: Booking.Presenters.DateTimePicker

  templateName: 'datetimepicker'

  viewClasses:
    calendar: Booking.Views.Calendar
    times: Booking.Views.TimeBubbles

  styleClassName: 'dates datestimes'

  attributes: ->
    'data-bhw': "#{Booking.bhw}Dates"

  constructor: ->
    Booking.Views.Picker.apply this, arguments

    @createViews()

    @listenTo @model, 'loadingEvent', @render

  clearSelection: ->
    @render()

  createViews: ->
    @views = {}

    @createView(
      name: 'calendar'
      options:
        collection: @collection
      events:
        select: @selectDates
        calendarRendered: @calendarRender
    )

    @createView(
      name: 'times'
      options:
        collection: @collection
      events:
        select: @selectTimes
    )

  detachContent: ->
    @views['calendar'].$el.detach()
    @views['times'].$el.detach()

  attachContent: ->
    @views['calendar'].$el.appendTo @container()
    @views['times'].$el.appendTo @container()

  createView: ({name, options, events}) ->
    @views[name] = new @viewClasses[name] _.extend({model: @model}, options)
    @listenTo(@views[name], eventName, eventCb) for eventName, eventCb of events
    return @views[name]

  isLoading: ->
    @model.isDateTimeLoading()

  show: ->
    @renderContent()
    Booking.Views.Picker::show.apply this, arguments

  renderContent: ->
    @views['calendar'].render()
    @views['times'].render()
    @views['times'].delegateEvents()

  dateSelected: (date) ->
    if @model.isBookerDeal()
      @$('.loading').show()

      {start, end} = Booking.Helpers.getDayRange(date)

      @model.loadAvailability(start, end)
        .done( => # Success
          @model.setSelectedTimes([])
          @views['times'].trigger 'picker:date:selected', date
        )
        .always( => # Always
          @$('.loading').hide()
        )
    else
      @views['times'].trigger 'picker:date:selected', date


  # If a date is selected, update the time list
  # selectedDate will take care of the currently selected date to be displayed in the calendar
  selectDates: (date) ->
    @model.selectDate date
    @closeTooltip()
    @showHideValidation()

  selectTimes: (time) ->
    targetType = ''
    if not @tooltip and @model.isMultiWindow() and not @anyTimeBubbleSelected()
      if time is null
        # Show tooltip on date
        element = @$el.find ".calendar-day-#{@model.getSelectedDate().format('YYYY-MM-DD')}"
        targetType = 'day'
      else
        # Show tooltip on time
        timetext = "#{time.start().format('h:mm A')}"
        timebubbles = @$el.find ".time-bubble"
        element = $(timebubbles).filter (index, item) -> $(item).text().replace(/\n/g,'').trim() is timetext
        targetType = 'bubble'

      @openTooltip(element, targetType)

    selectedTimes = @collection.getSelectedTimes()
    @select(selectedTimes, silent = @model.isMultiWindow())
    @hideInvalid()

  anyTimeBubbleSelected: ->
    this.$el.find(".anytime-bubble .time.selected").length

  prefill: -> #noop

  isSelectable: ->
    if @model.isBookerDeal()
      return true
    else
      Booking.Views.Picker::isSelectable.apply this, arguments

  setSelection: (selection) ->
    @hideNotice()
    @model.setSelectedTimes selection

  optionSelected: (attribute) ->
    @render()

    if attribute is 'selectedDate'
      @dateSelected @model.getSelectedDate()

  selected: ->
    @model.getSelectedTimes().length > 0 and !@notice

  openTooltip: (target, targetType) ->
    $target = $(target)
    @tooltip?.remove()
    if $target.length > 0
      @tooltip = new Booking.Views.Tooltip()
      @$el.find('tbody').append(@tooltip.render().el)
      @tooltip.open $target, targetType

  closeTooltip: ->
    @tooltip?.close()
